import angular from 'angular';
import constants from 'app/constants';
import {
  loaderService,
  ssDialogService,
  userService,
  vmDataService,
  vmSharedModelService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import viewContactsDialog from '../dialog.viewContactsDialog';
import editProductDialog from '../dialog.editProductDialog';
import confirmBeginRiskAssessmentDialog from './dialog.confirmBeginRiskAssessmentDialog';
import confirmControlsReviewDialog from './dialog.confirmControlsReviewDialog';
import selectRiskControlsForReviewDialog from './dialog.selectRiskControlsForReviewDialog';
import controller from './product.controller';
import directive from './product.directive';


export default angular.module('app.components.advisory.vendorManagement.product', [
  alerts,
  confirmDialog,
  constants,
  loaderService,
  ssDialogService,
  userService,
  vmDataService,
  vmSharedModelService,
  viewContactsDialog,
  editProductDialog,
  confirmBeginRiskAssessmentDialog,
  confirmControlsReviewDialog,
  selectRiskControlsForReviewDialog,
])
  .directive('vmProduct', directive)
  .controller('ProductController', controller)
  .name;

console.log('app.components.advisory.vendorManagement.product created');
